import { useEffect, useRef, type RefObject } from 'react';
import { CHAT_WIDGET_COPY, CHATWERK_FRAME_ID } from './chat-widget.constants';

/**
 * Moves focus into the chat window when it opens and back to the launcher when
 * it closes — ChatWerk removes the frame and would leave focus on <body>. The
 * frame also gets the accessible name ChatWerk does not set.
 */
export function useChatWindowFocus(isOpen: boolean, launcherRef: RefObject<HTMLButtonElement | null>) {
    const wasOpen = useRef(false);

    useEffect(() => {
        if (isOpen) {
            const frame = document.getElementById(CHATWERK_FRAME_ID);
            frame?.setAttribute('title', CHAT_WIDGET_COPY.frameTitle);
            frame?.focus();
        } else if (wasOpen.current && document.activeElement === document.body) {
            launcherRef.current?.focus();
        }

        wasOpen.current = isOpen;
    }, [isOpen, launcherRef]);
}
